import imgPrayatanYojana from "../assets/images/landing/slider-img-1.png";
import imgVeerChandYojana from "../assets/images/landing/slider-img-2.png";
import imgDeenDayalYojana from "../assets/images/landing/slider-img-4.png";
import imgTIFCFaciliation from "../assets/images/landing/slider-img-5.png";
import imgTourisPolicy2023 from "../assets/images/landing/slider-img-6.png";
import welcomeRightImage from "../assets/images/landing/welcome-right-image.png";
import govtIcon from "../assets/images/landing/gov-icon.png";
import tourismIcon from "../assets/images/landing/tourism-icon.png";
import imgSkilledManPower from "../assets/images/landing/skilled-manpower.png";
import iconPrayatanUddamiProtsahanYojna from "../assets/images/landing/icon-PrayatanUddamiProtsahanYojna.png";
import iconTourismPolicies2023 from "../assets/images/landing/icon-TourismPolicies2023.png";
import iconVeerChandSinghGarhwaliYojna from "../assets/images/landing/icon-VeerChandSinghGarhwaliYojna.png";
import iconDeenDayalUpadhyayYojna from "../assets/images/landing/icon-DeenDayalUpadhyayYojna.png";
import imgPrayatanUddamiProtsahanYojna from "../assets/images/landing/img-PrayatanUddamiProtsahanYojna.jpg";
import imgTourismPolicies2023 from "../assets/images/landing/img-TourismPolicies2023.jpg";
import imgVeerChandSinghGarhwaliYojna from "../assets/images/landing/img-VeerChandSinghGarhwaliYojna.jpg";
import imgDeenDayalUpadhyayYojna from "../assets/images/landing/img-DeenDayalUpadhyayYojna.jpg";
import imgIndustrySector from "../assets/images/landing/industry-sector.png";
import imgIndustryTourism from "../assets/images/landing/industry-tourism.jpg";
import imgIndustryAdeventure from "../assets/images/landing/industry-adventure.jpg";
import imgIndustryEdu from "../assets/images/landing/industry-edu.png";
import imgIndustryWellness from "../assets/images/landing/industry-wellness.jpg";
import imgIndustryIT from "../assets/images/landing/industry-it.jpg";
import imgIndustryAgriAllied from "../assets/images/landing/industry-agri.jpg";
import imgIndustryHealth from "../assets/images/landing/industry-health.jpg";
import imgIndustryRealEstate from "../assets/images/landing/industry-realestate.jpg";
import imgIndustryHeli from "../assets/images/landing/industry-heli.jpg";
import imgIndustryRenewable from "../assets/images/landing/industry-renewable.jpg";
import imgIndustryEducation from "../assets/images/landing/industry-education.jpg";
import imgTndustryEnergy from "../assets/images/landing/industry-energy.jpg";
import imgIndustryEstate from "../assets/images/landing/industry-estate.png";
import imgMsme from "../assets/images/landing/msme.jpg";
import imgFeature from "../assets/images/landing/feature.jpg";
import logoVana from "../assets/images/landing/vana-logo.png";
import logoLeisureHotels from "../assets/images/landing/leisure-hotels-logo.png";
import logoJaypee from "../assets/images/landing/jaypee-logo.png";
import logoFortune from "../assets/images/landing/fortune-logo.png";
import logoTaj from "../assets/images/landing/taj-logo.png";
import address from "../assets/images/landing/address.svg";
import mail from "../assets/images/landing/mail.svg";
import phone from "../assets/images/landing/phone-footer.svg";
import insta from "../assets/images/landing/instagram-ft.svg";
import linkedin from "../assets/images/landing/linkedin-ft.svg";
import pinterest from "../assets/images/landing/pinterest-ft.svg";
import facebook from "../assets/images/landing/facebook-ft.svg";
import twitter from "../assets/images/landing/twitter-ft.svg";
import youtube from "../assets/images/landing/youtube-ft.svg";
import govtLogos from "../assets/images/landing/govt-logos.svg";
import { DelhiNCRIcon, EconomicPowerIcon, IndustrialInfraIcon, InvestorFriendlyIcon, PeaceBusinessIcon, SingleWindowIcon, SkilledWorkforceIcon, SpiritualCapitalIcon } from "../icons/LandingPageIcons";
import { INVEST_UK_WEBSITE_URL } from "./apiConfig";
import SingleWindowPortalChart from "../components/Landing/SingleWindowPortalChart";
import PreEstOpService from "../components/Landing/PreEstOpService";
import SubsidyClaimRegistration from "../components/Landing/SubsidyClaimRegistration";
import peaceBusiness from "../assets/images/landing/peace-business.png";
import economicPower from "../assets/images/landing/economic-power.png";
import singleWindow from "../assets/images/landing/single-window.png";
import industrialInfra from "../assets/images/landing/industrial-infra.jpg";
import investorFriendly from "../assets/images/landing/investor-friendly.png";
import skilledWorkForce from "../assets/images/landing/skilled-work-force.png";
import spiritualCapital from "../assets/images/landing/spiritual-capital.png";
import delhiNCR from "../assets/images/landing/delhi-ncr.jpg";
import AffidavitPDF from "../assets/documents/Affidavit.pdf";
import CACertificatePDF from "../assets/documents/CA_Certificate.pdf";
import CEArchitectPDF from "../assets/documents/CEArchitechCertificate.pdf";
import CheckListPDF from "../assets/documents/Check_List.pdf";
import BankIntrestCertificatePDF from "../assets/documents/BankIntrestCertificate.pdf";
import OperationalGuidelinesParyatanUdyamiPDF from "../assets/documents/Operational_Guidelines_Paryatan_Udyami_Yojna_2024.PDF";
import GovernmentOrderParyatanUdhyamiPDF from "../assets/documents/GO_Uttarakhand_Paryatan_Udhyami_Protsahan_Yojna_2024.pdf";
import TourismPolicy2023PDF from "../assets/documents/Tourism_Policy_2023-30.pdf";
import AmendedModificationsTourismPolicy2023PDF from "../assets/documents/Amended_Modifications_Tourism_Policy_2023.pdf";
import OperationalGuidelinesTourismPolicy2023PDF from "../assets/documents/Operational_Guidelines_Tourism_Policy_2023-30.pdf";
import AmendmentOperationalGuidelinesTourismPolicy2023PDF from "../assets/documents/Amendment_Operational_Guidelines_Tourism Policy_2023.pdf";
import OGTourismPolicy2023Hindi from "../assets/documents/OG_Tourism_Policy 2023_Hindi.pdf";

// homePageUtils.js
export const navItems = [
    { label: { en: "Home", hi: "मुख्य पृष्ठ" }, sectionId: "" },
    { label: { en: "Policies & Schemes", hi: "नीतियाँ एवं योजनाएँ" }, sectionId: "Policies" },
    { label: { en: "Investment Sector", hi: "निवेश क्षेत्र" }, sectionId: "investment-sector" },
    { label: { en: "Growth of Tourism", hi: "पर्यटन विकास" }, sectionId: "tourism-growth" },
    { label: { en: "Opportunity", hi: "अवसर" }, sectionId: "opportunity" },
    { label: { en: "Statistics", hi: "आंकड़े" }, sectionId: "Statistics" },
    { label: { en: "Contact Us", hi: "संपर्क करें" }, sectionId: "contact-section" },
];

export const prayatanYojanaSections = [
    {
        id: "overview",
        label: {
            en: "Overview",
            hi: "अवलोकन",
        },
    },
    {
        id: "investment",
        label: {
            en: "Investment Limits",
            hi: "निवेश सीमाएँ",
        },
    },
    {
        id: "objectives",
        label: {
            en: "Scheme Objectives",
            hi: "योजना के उद्देश्य",
        },
    },
    {
        id: "eligibility",
        label: {
            en: "Eligibility",
            hi: "पात्रता",
        },
    },
    {
        id: "incentives",
        label: {
            en: "Financial Incentives",
            hi: "वित्तीय सहायता/अनुदान",
        },
    },
    {
        id: "categorization",
        label: {
            en: "Categorization",
            hi: "वर्गीकरण",
        },
    },
    {
        id: "application",
        label: {
            en: "Application Process & Contact",
            hi: "आवेदन प्रक्रिया एवं संपर्क",
        },
    },
    {
        id: "guidelines",
        label: {
            en: "Detailed Guidelines",
            hi: "विस्तृत दिशा-निर्देश",
        },
    },
];

export const yojanaBannerItems = {
    prayatanYojana: {
        image: imgPrayatanYojana,
        title: {
            en: "Uttarakhand Paryatan Udhyami Protsahan Yojana",
            hi: "उत्तराखंड पर्यटन उद्यमी प्रोत्साहन योजना",
        },
        description: {
            en: "Uttarakhand, renowned worldwide for its rich cultural heritage and natural beauty, has introduced an ambitious tourism scheme aimed at promoting capital investment by the state's permanent residents/entrepreneurs.",
            hi: "समृद्ध सांस्कृतिक विरासत एवं अद्वितीय प्राकृतिक सौन्दर्य के लिए विश्वविख्यात उत्तराखण्ड राज्य ने राज्य के स्थायी निवासियों/उद्यमियों द्वारा पूंजी निवेश को प्रोत्साहित करने हेतु एक महत्वाकांक्षी पर्यटन योजना प्रारम्भ की है।",
        },
        overview: {
            en: "Uttarakhand, renowned worldwide for its rich cultural heritage and natural beauty, has introduced an ambitious tourism scheme aimed at promoting capital investment by the state's permanent residents/entrepreneurs. The main goal of this scheme is to develop quality accommodation facilities and create employment opportunities in the tourism sector. This initiative will elevate Uttarakhand's tourism industry to new heights, increase local job opportunities, and significantly contribute to the state's economic development.",
            hi: "समृद्ध सांस्कृतिक विरासत एवं अद्वितीय प्राकृतिक सौन्दर्य के लिए विश्वविख्यात उत्तराखण्ड राज्य ने राज्य के स्थायी निवासियों/उद्यमियों द्वारा पूंजी निवेश को प्रोत्साहित करने हेतु एक महत्वाकांक्षी पर्यटन योजना प्रारम्भ की है। इस योजना का मुख्य उद्देश्य गुणवत्तापूर्ण आवासीय सुविधाओं का विकास करना तथा पर्यटन क्षेत्र में रोजगार के अवसर सृजित करना है। यह पहल उत्तराखण्ड के पर्यटन उद्योग को नई ऊँचाइयों तक ले जाने, स्थानीय स्तर पर रोजगार बढ़ाने तथा राज्य के समग्र आर्थिक विकास में महत्वपूर्ण योगदान देने में सहायक सिद्ध होगी।",
        },
    },

    veerChandYojana: {
        image: imgVeerChandYojana,
        title: {
            en: "Veer Chand Singh Garhwali, Tourism Self-Employment Scheme",
            hi: "वीरचंद्र सिंह गढ़वाली, पर्यटन स्वरोजगार योजना",
        },
        description: {
            en: "Since the formation of Uttarakhand, the state government has aimed to position Uttarakhand as a globally recognized tourism destination.",
            hi: "उत्तराखंड राज्य गठन के बाद से ही सरकार का लक्ष्य राज्य को वैश्विक पर्यटन गंतव्य के रूप में स्थापित करना रहा है।",
        },
        overview: {
            en: "Since the formation of Uttarakhand, the state government has aimed to position Uttarakhand as a globally recognized tourism destination. This scheme is designed to develop tourism as a major source of employment and revenue while integrating the local permanent residents into the socio-economic development of the region.",
            hi: "यह योजना पर्यटन को रोजगार और राजस्व का प्रमुख स्रोत बनाने के उद्देश्य से बनाई गई है, जिससे स्थानीय स्थायी निवासियों को सामाजिक-आर्थिक विकास की मुख्यधारा में जोड़ा जा सके।",
        },
    },

    deenDayalYojana: {
        image: imgDeenDayalYojana,
        title: {
            en: "Deen Dayal Upadhyay Housing Scheme (Home-Stay)",
            hi: "दीन दयाल उपाध्याय गृह आवास योजना",
        },
        description: {
            en: "The Deen Dayal Upadhyay Housing Scheme (Home-Stay) is being implemented in Uttarakhand with the objective of promoting urbanization.",
            hi: "दीन दयाल उपाध्याय गृह आवास योजना उत्तराखंड में शहरीकरण को बढ़ावा देने के उद्देश्य से लागू की गई है।",
        },
        overview: {
            en: "The Deen Dayal Upadhyay Housing Scheme (Home-Stay) is being implemented in Uttarakhand with the objective of promoting urbanization. Under this scheme, financial assistance has been provided for the construction of home-stay accommodations for the permanent/native residents of the state. Upon taking a loan from the bank, a subsidy of 50% up to ₹15 lakh is provided for rural areas along with an interest subsidy of up to ₹1.5 lakh for the first five years. Similarly, for urban areas, a 25% subsidy up to ₹7.5 lakh is provided along with an additional interest subsidy of ₹1 lakh for the first five years. The scheme was launched in 2018.",
            hi: "यह योजना स्थायी/स्थानीय निवासियों के लिए होम-स्टे निर्माण हेतु वित्तीय सहायता प्रदान करती है। ग्रामीण क्षेत्रों में 50% तक ₹15 लाख की सब्सिडी और शहरी क्षेत्रों में 25% तक ₹7.5 लाख की सब्सिडी प्रदान की जाती है। इसके अतिरिक्त पहले पाँच वर्षों के लिए ब्याज सब्सिडी भी दी जाती है। यह योजना वर्ष 2018 में प्रारंभ की गई थी।",
        },
    },

    tifcFaciliation: {
        image: imgTIFCFaciliation,
        title: {
            en: "Tourism Investment Facilitation Centre (TIFC)",
            hi: "पर्यटन निवेश सुविधा केंद्र (TIFC)",
        },
        description: {
            en: "UTDB has formed a Tourism Investment Facilitation Centre (TIFC) to coordinate between State Single Window Portal and the investor, in attaining necessary project sanctions, licenses, NOCs and approvals.",
            hi: "यूटीडीबी ने निवेशकों और राज्य सिंगल विंडो पोर्टल के बीच समन्वय के लिए पर्यटन निवेश सुविधा केंद्र (TIFC) की स्थापना की है।",
        },
        overview: {
            en: "",
            hi: "",
        },
    },

    tourismPolicy2023: {
        image: imgTourisPolicy2023,
        title: {
            en: "Uttarakhand Tourism Policy 2023",
            hi: "उत्तराखंड पर्यटन नीति 2023",
        },
        description: {
            en: "To facilitate private sector investment in the state to create and develop new tourism destinations and unique tourism products offering unmatched experience catering to various tourist segments, the Department of Tourism, Government of Uttarakhand, has announced the Uttarakhand Tourism Policy 2023.",
            hi: "निजी क्षेत्र के निवेश को प्रोत्साहित करने और नए पर्यटन स्थलों व विशिष्ट पर्यटन उत्पादों के विकास हेतु उत्तराखंड सरकार ने पर्यटन नीति 2023 की घोषणा की है।",
        },
        overview: {
            en: "The Tourism Policy is driven by the philosophy of enabling all stakeholders involved in the tourism sector to benefit from Uttarakhand's growth story.",
            hi: "यह पर्यटन नीति पर्यटन क्षेत्र से जुड़े सभी हितधारकों को उत्तराखंड की विकास यात्रा का लाभ देने के उद्देश्य से बनाई गई है।",
        },
    },
};

export const deenDayalYojanaObjectives = [
    {
        color: "border-[#F77B55]",
        text: {
            en: "To introduce tourists to the cultural heritage of the state while ensuring clean and proper housing and food facilities.",
            hi: "राज्य की सांस्कृतिक विरासत से पर्यटकों को परिचित कराना, साथ ही साफ-सुथरी और उचित आवास एवं भोजन सुविधाओं को सुनिश्चित करना।",
        },
    },
    {
        color: "border-yellow-500",
        text: {
            en: "The scheme is implemented across the state except in municipal corporation and municipal council areas.",
            hi: "योजना पूरे राज्य में लागू है, नगरपालिका निगम और परिषद क्षेत्रों को छोड़कर।",
        },
    },
    {
        color: "border-green-600",
        text: {
            en: "Create new employment opportunities and improve the quality of tourism services.",
            hi: "नई रोजगार संभावनाओं का सृजन करना और पर्यटन सेवाओं की गुणवत्ता में सुधार करना।",
        },
    },
    {
        color: "border-blue-500",
        text: {
            en: "Target Group – Primarily for permanent and native residents of rural areas in Uttarakhand.",
            hi: "लक्ष्य समूह – मुख्य रूप से उत्तराखंड के ग्रामीण क्षेत्रों के स्थायी और मूल निवासी।",
        },
    },
];

export const prayatanYojanaObjectives = [
    {
        color: "border-[#F77B55]",
        text: {
            en: "Encourage investment in the tourism industry.",
            hi: "पर्यटन उद्योग में निवेश को प्रोत्साहित करना।",
        },
    },
    {
        color: "border-yellow-500",
        text: {
            en: "Empower local entrepreneurs and involve them in high-grade tourism projects.",
            hi: "स्थानीय उद्यमियों को सशक्त बनाना और उन्हें उच्च गुणवत्ता वाली पर्यटन परियोजनाओं में शामिल करना।",
        },
    },
    {
        color: "border-green-600",
        text: {
            en: "Create new employment opportunities and improve the quality of tourism services.",
            hi: "नए रोजगार के अवसर सृजित करना और पर्यटन सेवाओं की गुणवत्ता में सुधार करना।",
        },
    },
    {
        color: "border-blue-500",
        text: {
            en: "Ensure inclusive development of tourism activities.",
            hi: "पर्यटन गतिविधियों का समावेशी विकास सुनिश्चित करना।",
        },
    },
];

export const veerChandYojanaSections = [
    { id: "overview", label: { en: "Overview", hi: "सारांश" } },
    { id: "applicability", label: { en: "Applicability", hi: "लागू होने योग्य" } },
    { id: "activities-covered", label: { en: "Activities Covered", hi: "कवरेज की गई गतिविधियां" } },
    { id: "eligibility", label: { en: "Eligibility", hi: "योग्यता" } },
    //{ id: "definition", label: { en: "Definition of Unemployment", hi: "बेरोज़गारी की परिभाषा" } },
    { id: "subsidy-grants", label: { en: "Subsidy & Grants", hi: "अनुदान और सहायता" } },
    { id: "loan-provisions", label: { en: "Loan Provisions", hi: "ऋण प्रावधान" } },
    { id: "implementation", label: { en: "Implementation", hi: "कार्यान्वयन" } },
];

export const veerChandActivities = [
    {
        srNo: 1,
        transport: [
            {
                en: "General tourist vehicles",
                hi: "सामान्य पर्यटक वाहन",
            },
            {
                en: "Taxi services",
                hi: "टैक्सी सेवाएं",
            },
            {
                en: "E-rickshaws",
                hi: "ई-रिक्शा",
            },
            {
                en: "Electric buses",
                hi: "इलेक्ट्रिक बसें",
            },
        ],
        nonTransport: [
            {
                en: "Development of hotels/lodges under the homestay scheme",
                hi: "होमस्टे योजना के अंतर्गत होटल/लॉज का विकास",
            },
            {
                en: "Construction of motor garages and parking facilities",
                hi: "मोटर गैरेज एवं पार्किंग सुविधाओं का निर्माण",
            },
            {
                en: "Establishment of fast-food centers",
                hi: "फास्ट फूड केंद्रों की स्थापना",
            },
            {
                en: "Establishment of meditation/yoga centers",
                hi: "ध्यान एवं योग केंद्रों की स्थापना",
            },
            {
                en: "Cultural tourism activities",
                hi: "सांस्कृतिक पर्यटन गतिविधियां",
            },
            {
                en: "Development of modern tourism information centers",
                hi: "आधुनिक पर्यटन सूचना केंद्रों का विकास",
            },
            {
                en: "Development of tourism residential facilities",
                hi: "पर्यटन आवासीय सुविधाओं का विकास",
            },
            {
                en: "Promotion of adventure tourism activities",
                hi: "साहसिक पर्यटन गतिविधियों को बढ़ावा देना",
            },
            {
                en: "Development of laundry services for tourism",
                hi: "पर्यटन हेतु लॉन्ड्री सेवाओं का विकास",
            },
            {
                en: "Establishment of tourism-based training centers",
                hi: "पर्यटन आधारित प्रशिक्षण केंद्रों की स्थापना",
            },
            {
                en: "Procurement of equipment for star-gazing and bird-watching",
                hi: "तारों के अवलोकन एवं पक्षी दर्शन हेतु उपकरणों की खरीद",
            },
            {
                en: "Herbal tourism initiatives",
                hi: "हर्बल पर्यटन पहल",
            },
            {
                en: "Operation of trekking and canoeing services",
                hi: "ट्रेकिंग एवं कैनोइंग सेवाओं का संचालन",
            },
            {
                en: "Equipment rental for adventure activities",
                hi: "साहसिक गतिविधियों हेतु उपकरण किराया सेवाएं",
            },
            {
                en: "Establishment of local handicraft and souvenir production units",
                hi: "स्थानीय हस्तशिल्प एवं स्मृति वस्तु निर्माण इकाइयों की स्थापना",
            },
            {
                en: "Development of floating hotels",
                hi: "फ्लोटिंग होटलों का विकास",
            },
            {
                en: "Establishment of trekking equipment rental hubs",
                hi: "ट्रेकिंग उपकरण किराया केंद्रों की स्थापना",
            },
            {
                en: "Other tourism-related projects approved by district-level committee",
                hi: "जिला स्तरीय समिति द्वारा स्वीकृत अन्य पर्यटन संबंधी परियोजनाएं",
            },
        ],
    },
];


export const veerChandEligibility = [
    {
        en: "The applicant must be a permanent resident of the state.",
        hi: "आवेदक राज्य का स्थायी निवासी होना चाहिए।",
    },
    {
        en: "If land is required for the implementation of the scheme, the applicant must either be the landowner or have a relevant legal relationship with the landowner. In such cases, land ownership will be considered a priority criterion. If the landowner is a co-owner or a legal heir, the grant amount will be provided only to the applicant, but they can still benefit from the scheme if the land lease period exceeds the loan repayment period.",
        hi: "यदि योजना के कार्यान्वयन के लिए भूमि आवश्यक है, तो आवेदक को भूमि का मालिक होना चाहिए या उसके साथ वैध कानूनी संबंध होना चाहिए। ऐसे मामलों में, भूमि की स्वामित्वता को प्राथमिकता मानदंड माना जाएगा। यदि भूमि के मालिक सह-मालिक या कानूनी उत्तराधिकारी हैं, तो अनुदान राशि केवल आवेदक को प्रदान की जाएगी, लेकिन यदि भूमि पट्टे की अवधि ऋण भुगतान अवधि से अधिक है, तो वे योजना का लाभ ले सकते हैं।",
    },
    {
        en: "The applicant should not be a defaulter of any bank or financial institution.",
        hi: "आवेदक किसी भी बैंक या वित्तीय संस्था का डिफॉल्टर नहीं होना चाहिए।",
    },
];

export const veerChandDefinition = [
    { en: "Minimum investment: ₹1 crore.", hi: "न्यूनतम निवेश: ₹1 करोड़।" },
    { en: "Maximum investment: ₹5 crores.", hi: "अधिकतम निवेश: ₹5 करोड़।" },
    { en: "Financial incentives based on category for investments exceeding ₹1 crore.", hi: "₹1 करोड़ से अधिक निवेश पर श्रेणी के अनुसार वित्तीय प्रोत्साहन प्रदान किए जाएंगे।" },
];

export const veerChandSubsidy = {
    nonTransport: [
        { region: { en: "Hilly", hi: "पहाड़ी क्षेत्र" }, subsidy: "33%", maxAmount: "₹33 lakh" },
        { region: { en: "Plains", hi: "मैदानी क्षेत्र" }, subsidy: "25%", maxAmount: "₹25 lakh" },
    ],
    transport: [
        { region: { en: "Hilly/Plains", hi: "पहाड़ी/मैदानी क्षेत्र" }, subsidy: "25%", maxAmount: "₹10 lakh" },
        { type: { en: "Electric vehicles", hi: "इलेक्ट्रिक वाहन" }, note: { en: "Special provision for electric vehicles", hi: "इलेक्ट्रिक वाहनों के लिए विशेष प्रावधान" } },
        { type: { en: "Electric buses/taxis", hi: "इलेक्ट्रिक बस/टैक्सी" }, subsidy: "50%", maxAmount: "₹20 lakh" },
        { type: { en: "Limit", hi: "सीमा" }, note: { en: "Max 50 electric vehicles eligible per financial year, meeting specified standards", hi: "प्रत्येक वित्तीय वर्ष में अधिकतम 50 इलेक्ट्रिक वाहन पात्र होंगे, जो निर्दिष्ट मानकों को पूरा करते हैं" } },
    ],
};

export const subsidyGrants = [
    {
        category: { en: "(A) Non–Transport Activities", hi: "(A) गैर-परिवहन गतिविधियाँ" },
        items: [
            { label: { en: "Hilly regions:", hi: "पहाड़ी क्षेत्र:" }, description: { en: "Maximum subsidy of 33%, up to ₹33 lakh.", hi: "अधिकतम अनुदान 33%, ₹33 लाख तक।" } },
            { label: { en: "Plains:", hi: "मैदानी क्षेत्र:" }, description: { en: "Maximum subsidy of 25%, up to ₹25 lakh.", hi: "अधिकतम अनुदान 25%, ₹25 लाख तक।" } },
        ],
    },
    {
        category: { en: "(B) Transport–Based Activities", hi: "(B) परिवहन-आधारित गतिविधियाँ" },
        items: [
            { label: { en: "Hilly and plain regions:", hi: "पहाड़ी और मैदानी क्षेत्र:" }, description: { en: "Maximum subsidy of 25%, up to ₹10 lakh.", hi: "अधिकतम अनुदान 25%, ₹10 लाख तक।" } },
            { label: { en: "", hi: "" }, description: { en: "Special provision for electric vehicles.", hi: "इलेक्ट्रिक वाहनों के लिए विशेष प्रावधान।" } },
            { label: { en: "", hi: "" }, description: { en: "Electric buses (30-seater or 42-seater) and electric taxis will be eligible for 50% subsidy, up to ₹20 lakh.", hi: "इलेक्ट्रिक बस (30-सीटर या 42-सीटर) और इलेक्ट्रिक टैक्सी 50% अनुदान के लिए पात्र होंगी, ₹20 लाख तक।" } },
            { label: { en: "", hi: "" }, description: { en: "The subsidy applies only to vehicles that meet specified standards, with a maximum of 50 electric vehicles eligible per financial year.", hi: "अनुदान केवल उन वाहनों पर लागू होगा जो निर्दिष्ट मानकों को पूरा करते हैं, प्रत्येक वित्तीय वर्ष में अधिकतम 50 इलेक्ट्रिक वाहन पात्र होंगे।" } },
        ],
    },
];

export const deenDayalYojanaSections = [
    { id: "overview", label: { en: "Overview", hi: "सारांश" } },
    { id: "objectives", label: { en: "Scheme Objectives", hi: "योजना के उद्देश्य" } },
    { id: "eligibility", label: { en: "Eligibility", hi: "योग्यता" } },
    { id: "application-submission", label: { en: "Application Submission", hi: "आवेदन सबमिशन" } },
    { id: "required-documents", label: { en: "Required Documents", hi: "आवश्यक दस्तावेज़" } },
];

export const deenDayalEligibility = [
    {
        en: "Under the scheme, the house owner, along with their family, must reside in the house, and a minimum of one and a maximum of six rooms are allowed for home-stay facilities.",
        hi: "योजना के तहत, घर के मालिक को अपने परिवार के साथ घर में रहना आवश्यक है, और होम-स्टे सुविधाओं के लिए न्यूनतम एक और अधिकतम छह कमरे ही अनुमति हैं।",
    },
    {
        en: "Registration of the home-stay must be done under the Uttarakhand Tourism Development Board.",
        hi: "होम-स्टे का पंजीकरण उत्तराखंड पर्यटन विकास बोर्ड के तहत किया जाना चाहिए।",
    },
    {
        en: "This scheme is exclusively for the permanent residents of Uttarakhand.",
        hi: "यह योजना केवल उत्तराखंड के स्थायी निवासियों के लिए है।",
    },
    {
        en: "The scheme applies across the entire state except for municipal corporation and council areas. Apart from constructing new home-stay accommodations, the scheme also facilitates renovation, expansion, modernization, and improvement of old houses, as well as the construction of essential facilities such as toilets.",
        hi: "यह योजना पूरे राज्य में लागू है, नगरपालिका निगम और परिषद क्षेत्रों को छोड़कर। नई होम-स्टे सुविधाओं के निर्माण के अलावा, यह योजना पुराने घरों के नवीनीकरण, विस्तार, आधुनिकीकरण और सुधार में भी सहायता करती है, साथ ही शौचालय जैसी आवश्यक सुविधाओं के निर्माण में भी।",
    },
    {
        en: "Preference will be given to traditional or eco-friendly houses built using local materials.",
        hi: "स्थानीय सामग्रियों का उपयोग करके बनाए गए पारंपरिक या इको-फ्रेंडली घरों को प्राथमिकता दी जाएगी।",
    },
];

export const deenDayalRequiredDocuments = [
    { icon: "📄", text: { en: "Birth Certificate / Age Proof", hi: "जन्म प्रमाण पत्र / आयु प्रमाण" } },
    { icon: "🎓", text: { en: "Educational Qualification Certificate", hi: "शैक्षणिक योग्यता प्रमाण पत्र" } },
    { icon: "🆔", text: { en: "Aadhaar Card", hi: "आधार कार्ड" } },
    { icon: "🏷️", text: { en: "Caste Certificate (if applicable)", hi: "जाति प्रमाण पत्र (यदि लागू हो)" } },
    { icon: "📍", text: { en: "Proof of Permanent Residence in Uttarakhand", hi: "उत्तराखंड में स्थायी निवास का प्रमाण" } },
    { icon: "🏠", text: { en: "Land / House Ownership Documents", hi: "भूमि / घर के स्वामित्व के दस्तावेज़" } },
    { icon: "📑", text: { en: "Scheme Approval Letter", hi: "योजना स्वीकृति पत्र" } },
];

export const tifcFacilationSections = [
    {
        id: "tifc-details",
        label: {
            en: "Tourism Investment Facilitation",
            hi: "पर्यटन निवेश सुविधा केंद्र",
        },
    },
];

export const tourismPolicy2023CapitalSubsidyData = {
    heading: { en: "Capital Subsidy & Incentives", hi: "पूंजी सब्सिडी और प्रोत्साहन" },

    table: {
        title: {
            en: "1. Capital Subsidy for Hospitality Projects (Hotels, Resorts etc.)",
            hi: "1. आतिथ्य परियोजनाओं (होटल, रिसॉर्ट आदि) के लिए पूंजी सब्सिडी",
        },
        description: [
            {
                en: "a. Maximum Capital Subsidy as per category defined in table below.",
                hi: "क. नीचे दी गई तालिका में परिभाषित श्रेणी के अनुसार अधिकतम पूंजी सब्सिडी।",
            },
            {
                en: "b. To be paid in 10 equal annual instalments from the date of COD.",
                hi: "ख. COD की तारीख से 10 समान वार्षिक किश्तों में भुगतान किया जाएगा।",
            },
            {
                en: "c. On a yearly basis – 10% of maximum subsidy or 75% of SGST for the preceding 12 months PLUS additional incentives, whichever is lower.",
                hi: "ग. वार्षिक आधार पर – अधिकतम सब्सिडी का 10% या पिछले 12 महीनों के SGST का 75% प्लस अतिरिक्त प्रोत्साहन, जो भी कम हो।",
            },
            {
                en: "Additional incentives for Hospitality Projects",
                hi: "आतिथ्य परियोजनाओं के लिए अतिरिक्त प्रोत्साहन",
            },
        ],
        points: [
            {
                en: "Incentive for marketing & promotion – 1% of Maximum Capital Subsidy",
                hi: "मार्केटिंग और प्रचार के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 1%",
            },
            {
                en: "Incentive for Training and Skilling – 0.5% of Maximum Capital Subsidy",
                hi: "प्रशिक्षण और कौशल विकास के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 0.5%",
            },
            {
                en: "Interest Subvention – 1% of Maximum Capital Subsidy",
                hi: "सूद सब्सिडी – अधिकतम पूंजी सब्सिडी का 1%",
            },
            {
                en: "Incentive for Waste Treatment – 0.25% of Maximum Capital Subsidy",
                hi: "अपशिष्ट प्रबंधन के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 0.25%",
            },
            {
                en: "Bookings generated through State developed Online Travel Agency / platform – 0.25% of Maximum Capital Subsidy",
                hi: "राज्य द्वारा विकसित ऑनलाइन ट्रैवल एजेंसी / प्लेटफ़ॉर्म के माध्यम से बुकिंग – अधिकतम पूंजी सब्सिडी का 0.25%",
            },
        ],
        rows: [
            {
                category: "A",
                criteria: [
                    {
                        en: "Whole Districts of Haridwar, Nainital and Udham Singh Nagar",
                        hi: "हरिद्वार, नैनीताल और उधम सिंह नगर के पूरे जिले",
                    },
                    {
                        en: "Areas of District Dehradun which are not included in Category B",
                        hi: "जिला देहरादून के वे क्षेत्र जो श्रेणी B में शामिल नहीं हैं",
                    },
                    {
                        en: "Ranikhet and Almora Tehsils of District Almora",
                        hi: "अल्मोड़ा जिले के रानीखेत और अल्मोड़ा तहसील",
                    },
                ],
                maxSubsidy: "25%",
            },
            {
                category: "B",
                criteria: [
                    {
                        en: "Remaining area of District Almora (which are not included in Category A)",
                        hi: "अल्मोड़ा जिले का शेष क्षेत्र (जो श्रेणी A में शामिल नहीं है)",
                    },
                    {
                        en: "Kalsi, Chakrata and Tyuni Tehsils of District Dehradun",
                        hi: "जिला देहरादून के कालसी, चकराता और ट्यूनि तहसील",
                    },
                    {
                        en: "Garud Tehsil of District Bageshwar",
                        hi: "बागेश्वर जिले की गरुड़ तहसील",
                    },
                    {
                        en: "Kotdwar, Lansdowne, Yamkeshwar and Dhoomakot tehsils of District Pauri Garhwal",
                        hi: "पौड़ी गढ़वाल जिले के कोटद्वार, लैंसडाउन, यमकेश्वर और धूमकोट तहसील",
                    },
                    {
                        en: "Dhanaulti & Narendranagar tehsils of District Tehri Garhwal",
                        hi: "टिहरी गढ़वाल जिले के धनौल्टी और नरेंद्रनगर तहसील",
                    },
                ],
                maxSubsidy: "35%",
            },
            {
                category: "C",
                criteria: [
                    {
                        en: "Whole Districts of Uttarkashi, Chamoli, Champawat, Rudraprayag and Pithoragarh",
                        hi: "उत्तरकाशी, चमोली, चंपावत, रुद्रप्रयाग और पिथौरागढ़ के पूरे जिले",
                    },
                    {
                        en: "Remaining area of Districts Bageshwar, Pauri Garhwal and Tehri Garhwal (which are not included in Category B)",
                        hi: "बागेश्वर, पौड़ी गढ़वाल और टिहरी गढ़वाल जिलों का शेष क्षेत्र (जो श्रेणी B में शामिल नहीं है)",
                    },
                ],
                maxSubsidy: "50%",
            },
        ],
    },

    cards: [
        {
            title: {
                en: "2. Capital Subsidy for Development of Tourism Products & Services",
                hi: "2. पर्यटन उत्पादों और सेवाओं के विकास के लिए पूंजी सब्सिडी",
            },
            description: [
                {
                    en: "a. 100% capital subsidy.",
                    hi: "क. 100% पूंजी सब्सिडी।",
                },
                {
                    en: "b. To be paid in 5 equal annual instalments from the date of COD.",
                    hi: "ख. COD की तारीख से 5 समान वार्षिक किश्तों में भुगतान किया जाएगा।",
                },
                {
                    en: "c. On a yearly basis – 20% of maximum subsidy or 75% of SGST for the preceding 12 months PLUS additional incentives, whichever is lower.",
                    hi: "ग. वार्षिक आधार पर – अधिकतम सब्सिडी का 20% या पिछले 12 महीनों के SGST का 75% प्लस अतिरिक्त प्रोत्साहन, जो भी कम हो।",
                },
                {
                    en: "Additional incentives for Development of Tourism Products & Services",
                    hi: "पर्यटन उत्पादों और सेवाओं के विकास के लिए अतिरिक्त प्रोत्साहन",
                },
            ],
            list: [
                {
                    en: "Incentive for marketing & promotion – 2% of Maximum Capital Subsidy",
                    hi: "मार्केटिंग और प्रचार के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 2%",
                },
                {
                    en: "Incentive for Training and Skilling – 2% of Maximum Capital Subsidy",
                    hi: "प्रशिक्षण और कौशल विकास के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 2%",
                },
                {
                    en: "Interest Subvention",
                    hi: "सूद सब्सिडी",
                },
                {
                    en: "Incentive for Waste Treatment – 2% of Maximum Capital Subsidy",
                    hi: "अपशिष्ट प्रबंधन के लिए प्रोत्साहन – अधिकतम पूंजी सब्सिडी का 2%",
                },
                {
                    en: "Bookings through State developed Online Travel Agency / platform – 1% of Maximum Capital Subsidy",
                    hi: "राज्य द्वारा विकसित ऑनलाइन ट्रैवल एजेंसी / प्लेटफ़ॉर्म के माध्यम से बुकिंग – अधिकतम पूंजी सब्सिडी का 1%",
                },
            ],
        },
        {
            title: {
                en: "3. Incentives for Units Not Availing Capital Subsidy",
                hi: "3. पूंजी सब्सिडी का लाभ न लेने वाली इकाइयों के लिए प्रोत्साहन",
            },
            list: [
                {
                    en: "High-value premium hospitality – 1% of Eligible Turnover",
                    hi: "उच्च मूल्य वाली प्रीमियम आतिथ्य – पात्र टर्नओवर का 1%",
                },
                {
                    en: "Attraction of foreign tourists – 1% of Eligible Turnover",
                    hi: "विदेशी पर्यटकों को आकर्षित करना – पात्र टर्नओवर का 1%",
                },
                {
                    en: "Organization of MICE, art, social & cultural events, fairs and festivals – 1% of Eligible Turnover",
                    hi: "MICE, कला, सामाजिक और सांस्कृतिक कार्यक्रम, मेले और त्योहारों का आयोजन – पात्र टर्नओवर का 1%",
                },
            ],
        },
        {
            title: { en: "4. Incentives for Heli-Transport", hi: "4. हेलिकॉप्टर परिवहन के लिए प्रोत्साहन" },
            description: [{ en: "INR 500 per leg per tourist", hi: "प्रत्येक पर्यटक के लिए प्रत्येक मार्ग पर INR 500" }],
        },
        {
            title: { en: "5. Reimbursement of Electricity Duty", hi: "5. विद्युत शुल्क की प्रतिपूर्ति" },
            description: [{ en: "Only for New Projects", hi: "केवल नए परियोजनाओं के लिए" }],
        },
        {
            title: { en: "6. Reimbursement of Stamp Duty", hi: "6. स्टांप ड्यूटी की प्रतिपूर्ति" },
            description: [{ en: "Only for New Projects", hi: "केवल नए परियोजनाओं के लिए" }],
        },
    ],

    applyUrl: "pdf-detail-3.html",
};

export const tourismPolicy2023Sections = [
    { id: "overview", label: { en: "Overview", hi: "सारांश" } },
    { id: "policy-validity", label: { en: "Policy Validity", hi: "नीति की वैधता" } },
    { id: "capital-subsidy", label: { en: "Capital Subsidy & Incentives", hi: "पूंजी सब्सिडी और प्रोत्साहन" } },
    { id: "guidelines", label: { en: "Guidelines", hi: "दिशा-निर्देश" } },
];

export const tifcFaciliationEligibility = [
    {
        text: {
            en: "UTDB has formed a Tourism Investment Facilitation Centre (TIFC) to coordinate between State Single Window Portal and the investor, in attaining necessary project sanctions, licenses, NOCs and approvals.",
            hi: "UTDB ने Tourism Investment Facilitation Centre (TIFC) की स्थापना की है ताकि राज्य सिंगल विंडो पोर्टल और निवेशक के बीच आवश्यक परियोजना स्वीकृतियाँ, लाइसेंस, NOC और अनुमोदन प्राप्त करने में समन्वय किया जा सके।",
        },
    },
    {
        text: {
            en: "Create new employment opportunities and improve the quality of tourism services.",
            hi: "नई रोजगार संभावनाओं का सृजन करना और पर्यटन सेवाओं की गुणवत्ता में सुधार करना।",
        },
    },
    {
        text: {
            en: "TIFC contact no. 0135-3515001/3515003/3510143",
            hi: "TIFC संपर्क नंबर: 0135-3515001/3515003/3510143",
        },
    },
];

export const slides = [
    {
        img: imgPrayatanYojana,
        title: {
            en: "Uttarakhand Paryatan <br/> Udhyami Protsahan Yojana",
            hi: "उत्तराखंड पर्यटन <br/> उद्यमी प्रोत्साहन योजना",
        },
        desc: {
            en: "Uttarakhand, renowned worldwide for its rich cultural heritage and natural beauty, has introduced an ambitious tourism scheme aimed at promoting capital investment by the state's permanent residents/entrepreneurs.",
            hi: "समृद्ध सांस्कृतिक विरासत एवं अद्वितीय प्राकृतिक सौन्दर्य के लिए विश्वविख्यात उत्तराखण्ड राज्य ने राज्य के स्थायी निवासियों/उद्यमियों द्वारा पूंजी निवेश को प्रोत्साहित करने हेतु एक महत्वाकांक्षी पर्यटन योजना प्रारम्भ की है।",
        },
        to: "/prayatan-yojana",
    },

    {
        img: imgVeerChandYojana,
        title: {
            en: "Veer Chand Singh Garhwali </br> Tourism Self-Employment Scheme",
            hi: "वीरचंद्र सिंह गढ़वाली </br> पर्यटन स्वरोजगार योजना",
        },
        desc: {
            en: "Since the formation of Uttarakhand, the state government has aimed to position Uttarakhand as a globally recognized tourism.",
            hi: "उत्तराखंड राज्य गठन के बाद से सरकार का लक्ष्य इसे एक प्रमुख पर्यटन स्थल के रूप में विकसित करना रहा है। यह योजना रोजगार और आय के अवसर बढ़ाने पर केंद्रित है।",
        },
        to: "/veer-chand-yojana",
    },

    {
        img: imgDeenDayalYojana,
        title: {
            en: "Deen Dayal <br/> Upadhyay Yojana",
            hi: "दीन दयाल उपाध्याय <br/> गृह आवास योजना",
        },
        desc: {
            en: "The Deen Dayal Upadhyay Housing Scheme (Home-Stay) is being implemented in Uttarakhand.",
            hi: "दीन दयाल उपाध्याय गृह आवास योजना उत्तराखंड में लागू की जा रही है, जिससे स्थानीय निवासियों को आय का नया साधन मिलता है।",
        },
        to: "/deen-dayal-yojana",
    },

    {
        img: imgTIFCFaciliation,
        title: {
            en: "Tourism Investment <br/> Facilitation Centre (TIFC)",
            hi: "पर्यटन निवेश <br/> सुविधा केंद्र (TIFC)",
        },
        desc: {
            en: "UTDB has formed a Tourism Investment Facilitation Centre (TIFC) to coordinate between investor and departments.",
            hi: "UTDB द्वारा पर्यटन निवेश सुविधा केंद्र (TIFC) की स्थापना की गई है, जो निवेशकों और विभागों के बीच समन्वय का कार्य करता है।",
        },
        to: "/tifc-faciliation",
    },

    {
        img: imgTourisPolicy2023,
        title: {
            en: "Tourism Policy <br/> 2023",
            hi: "पर्यटन नीति <br/> 2023",
        },
        desc: {
            en: "To facilitate private sector investment in the state, Uttarakhand has announced Tourism Policy 2023.",
            hi: "राज्य में निजी क्षेत्र के निवेश को बढ़ावा देने के लिए उत्तराखंड पर्यटन नीति 2023 लागू की गई है।",
        },
        to: "/tourism-policy-2023",
    },
];

export const welcomeData = {
    title: {
        en: "Welcome to",
        hi: "इन्वेस्ट उत्तराखंड में आपका स्वागत है",
    },

    highlight: {
        en: "Invest Uttarakhand",
        hi: "",
    },

    description: {
        en: `Uttarakhand is one of the most diverse and serene tourism hubs. The State has 
an unbeatable combination of Single Point Clearances, Subsidies and 
incentives for investment, Cheap Power, Clean Water, Highly skilled 
manpower, Good law & order, Proximity to National Capital Region with its 
huge Tourist arrivals (Highest in the hilly states of India), world-renowned 
education system, Wild-life sanctuaries, Flora and Fauna, peaceful & friendly 
people provide an 
dedicated Relationship managers for Investors to guide them through the 
unmatched quality of life to its residents`,

        hi: `उत्तराखण्ड देश के सर्वाधिक विविधतापूर्ण एवं शांत पर्यटन केंद्रों में से एक है। राज्य निवेशकों के लिए सिंगल विंडो क्लीयरेंस, आकर्षक सब्सिडी एवं प्रोत्साहन, सस्ती विद्युत, स्वच्छ जल, उच्च कौशलयुक्त मानव संसाधन, सुदृढ़ कानून-व्यवस्था तथा राष्ट्रीय राजधानी क्षेत्र के निकट स्थित होने के कारण विशाल पर्यटक आगमन (भारत के पर्वतीय राज्यों में सर्वाधिक) जैसी अद्वितीय सुविधाओं का उत्कृष्ट संयोजन प्रदान करता है। इसके अतिरिक्त, विश्वस्तरीय शिक्षा प्रणाली, समृद्ध वन्यजीव अभयारण्य, विविध वनस्पति एवं जीव-जंतु, शांतिप्रिय एवं सौहार्दपूर्ण जनसमुदाय राज्य के निवासियों को उत्कृष्ट जीवन गुणवत्ता प्रदान करते हैं।`,
    },

    buttonText: {
        en: "Invest Now For Better Future",
        hi: "बेहतर भविष्य के लिए निवेश करें",
    },

    buttonLink: INVEST_UK_WEBSITE_URL,

    image: welcomeRightImage,

    badge: {
        rank: { en: "1st", hi: "प्रथम" },
        text: {
            en: "Rank in NITI Aayog’s\nSDG ranking",
            hi: "नीति आयोग की SDG रैंकिंग में प्रथम स्थान",
        },
    },
};

export const advantagesData = {
    title: {
        en: "Advantage",
        hi: "लाभ",
    },

    highlight: {
        en: "of Uttarakhand",
        hi: "उत्तराखंड के",
    },

    cards: [
        {
            title: {
                en: "Proactive Governance",
                hi: "सक्रिय शासन व्यवस्था",
            },
            bgClass: "bg-card-1",
            icon: govtIcon,
            points: [
                {
                    en: "Proactive facilitation and attractive policies",
                    hi: "सक्रिय निवेश सुविधा एवं आकर्षक नीतियाँ",
                },
                {
                    en: "Simplified procedure and speedy time bound approvals",
                    hi: "स्वच्छ एवं प्राकृतिक वातावरण के लिए उत्कृष्ट पर्यटन स्थल",
                },
                {
                    en: "Strong industrial - zero tolerance policy",
                    hi: "सुदृढ़ औद्योगिक व्यवस्था – शून्य सहनशीलता नीति",
                },
            ],
        },

        {
            title: {
                en: "Tourism Attraction",
                hi: "पर्यटन आकर्षण",
            },
            bgClass: "bg-card-2",
            icon: tourismIcon,
            points: [
                {
                    en: "One of the best tourism states in India",
                    hi: "भारत के प्रमुख एवं सर्वश्रेष्ठ पर्यटन राज्यों में से एक",
                },
                {
                    en: "Great places to visit for pristine natural environment",
                    hi: "स्वच्छ एवं प्राकृतिक वातावरण के लिए उत्कृष्ट पर्यटन स्थल",
                },
                {
                    en: "Renowned wellness and tourism destinations",
                    hi: "प्रसिद्ध वेलनेस एवं पर्यटन गंतव्य",
                },
            ],
        },

        {
            title: {
                en: "Skilled Manpower",
                hi: "कुशल मानव संसाधन",
            },
            bgClass: "bg-card-3",
            icon: imgSkilledManPower,
            points: [
                {
                    en: "78.8% Literacy rate, above national average",
                    hi: "78.8% साक्षरता दर, राष्ट्रीय औसत से अधिक",
                },
                {
                    en: "Highest increase in technical institutes over 6 years",
                    hi: "पिछले 6 वर्षों में तकनीकी संस्थानों की संख्या में सर्वाधिक वृद्धि",
                },
                {
                    en: "Total 3532 private educational institutes",
                    hi: "कुल 3,532 निजी शैक्षणिक संस्थान",
                },
            ],
        },
    ],
};

export const policiesData = {
    heading: {
        en: "POLICIES",
        hi: "नीतियाँ",
    },

    tabs: [
        {
            id: "tab1",
            title: {
                en: "Uttarakhand Paryatan Udhyami Protsahan Yojana",
                hi: "उत्तराखंड पर्यटन उद्यमी प्रोत्साहन योजना",
            },
            icon: iconPrayatanUddamiProtsahanYojna,
            iconClasses: "brightness-0",
            img: imgPrayatanUddamiProtsahanYojna,
            to: "/prayatan-yojana",
            description: {
                en: "Uttarakhand, renowned worldwide for its rich cultural heritage and natural beauty, has introduced an ambitious tourism scheme aimed at promoting capital investment by the state's permanent residents/entrepreneurs.",
                hi: "समृद्ध सांस्कृतिक विरासत एवं अद्वितीय प्राकृतिक सौन्दर्य के लिए विश्वविख्यात उत्तराखण्ड राज्य ने राज्य के स्थायी निवासियों/उद्यमियों द्वारा पूंजी निवेश को प्रोत्साहित करने हेतु एक महत्वाकांक्षी पर्यटन योजना प्रारम्भ की है।",
            },
            active: true,
        },

        {
            id: "tab4",
            title: {
                en: "Deen Dayal Upadhyay Housing Scheme (Home-Stay)",
                hi: "दीन दयाल उपाध्याय गृह आवास योजना",
            },
            icon: iconDeenDayalUpadhyayYojna,
            iconClasses: "brightness-0",
            img: imgDeenDayalUpadhyayYojna,
            to: "/deen-dayal-yojana",
            description: {
                en: "Deen Dayal Upadhyaya Grah Aawas (Home-Stay) Vikas Yojana is a Uttarakhand government initiative aimed at promoting rural tourism, creating employment, and curbing migration by encouraging locals to turn their homes into homestays.",
                hi: "दीनदयाल उपाध्याय गृह आवास (होम-स्टे) विकास योजना उत्तराखण्ड सरकार की एक महत्त्वपूर्ण पहल है, जिसका उद्देश्य ग्रामीण पर्यटन को बढ़ावा देना, स्थानीय स्तर पर रोजगार के अवसर सृजित करना तथा पलायन की प्रवृत्ति को कम करना है। इस योजना के अंतर्गत स्थानीय निवासियों को अपने घरों को होम-स्टे के रूप में विकसित करने हेतु प्रोत्साहित किया जाता है।",
            },
            active: false,
        },

        {
            id: "tab3",
            title: {
                en: "Veer Chand Singh Garhwali, Tourism Self-Employment Scheme",
                hi: "वीरचंद्र सिंह गढ़वाली, पर्यटन स्वरोजगार योजना",
            },
            icon: iconVeerChandSinghGarhwaliYojna,
            iconClasses: "brightness-0",
            img: imgVeerChandSinghGarhwaliYojna,
            to: "/veer-chand-yojana",
            description: {
                en: "Veer Chandra Singh Garhwali Tourism Self-Employment Scheme provides subsidies to Unemployed state's residents for tourism-based businesses to create self-employment. It offers capital subsidy for projects like hotels, transport, and, adventure activities, targeting unemployed residents.",
                hi: "वीर चन्द्र सिंह गढ़वाली पर्यटन स्वरोजगार योजना के अंतर्गत राज्य के बेरोजगार निवासियों को पर्यटन आधारित व्यवसाय स्थापित करने हेतु अनुदान प्रदान किया जाता है, जिससे स्वरोजगार के अवसर सृजित हो सकें। इस योजना में होटल, परिवहन तथा साहसिक गतिविधियों जैसी परियोजनाओं के लिए पूंजीगत अनुदान उपलब्ध कराया जाता है, जिसका उद्देश्य स्थानीय युवाओं को आत्मनिर्भर बनाना है।",
            },
            active: false,
        },

        {
            id: "tab2",
            title: {
                en: "Tourism Policy 2023",
                hi: "पर्यटन नीति 2023",
            },
            icon: iconTourismPolicies2023,
            iconClasses: "brightness-0",
            img: imgTourismPolicies2023,
            to: "/tourism-policy-2023",
            description: {
                en: "Uttarakhand Tourism Policy 2023, aims to boost sustainable tourism, encourage private investment, and create local employment by offering significant subsidies and incentives.",
                hi: "उत्तराखण्ड पर्यटन नीति 2023 का उद्देश्य सतत (सस्टेनेबल) पर्यटन को बढ़ावा देना, निजी निवेश को प्रोत्साहित करना तथा स्थानीय स्तर पर रोजगार सृजन करना है। इसके अंतर्गत निवेशकों को आकर्षित करने हेतु विभिन्न सब्सिडी एवं प्रोत्साहन प्रदान किए जाते हैं।",
            },
            active: false,
        },
    ],
};

export const preEstablishmentServices = [
    {
        id: 1,
        serviceName: {
            en: "Change of Land Use",
            hi: "भूमि उपयोग परिवर्तन",
        },
        department: {
            en: "Revenue",
            hi: "राजस्व",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 2,
        serviceName: {
            en: "Application for New Electricity Connection (LT/HT Non-Domestic/Industrial)",
            hi: "नए विद्युत कनेक्शन हेतु आवेदन (एलटी/एचटी गैर-घरेलू/औद्योगिक)",
        },
        department: {
            en: "UPCL",
            hi: "यूपीसीएल",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 3,
        serviceName: {
            en: "Pre-Establishment Fire NOC",
            hi: "पूर्व-स्थापना अग्नि अनापत्ति प्रमाण पत्र (Fire NOC)",
        },
        department: {
            en: "Fire",
            hi: "अग्निशमन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 4,
        serviceName: {
            en: "Environmental Clearance Certificate",
            hi: "पर्यावरणीय स्वीकृति प्रमाण पत्र",
        },
        department: {
            en: "SEIAA",
            hi: "एसईआईएए",
        },
        centralState: {
            en: "State & Central",
            hi: "राज्य एवं केंद्र",
        },
        portal: "https://parivesh.nic.in",
    },
    {
        id: 5,
        serviceName: {
            en: "NOC for Tree Felling",
            hi: "वृक्ष कटान हेतु अनापत्ति प्रमाण पत्र",
        },
        department: {
            en: "Forest",
            hi: "वन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 6,
        serviceName: {
            en: "Tree Transit Permit",
            hi: "लकड़ी परिवहन परमिट",
        },
        department: {
            en: "Forest",
            hi: "वन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 7,
        serviceName: {
            en: "Construction Permit (Building Plan Approval)",
            hi: "निर्माण अनुमति (भवन मानचित्र स्वीकृति)",
        },
        department: {
            en: "Housing",
            hi: "आवास",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 8,
        serviceName: {
            en: "Plinth Level Inspection",
            hi: "प्लिंथ स्तर निरीक्षण",
        },
        department: {
            en: "Housing / SIDA",
            hi: "आवास / सिडा",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 9,
        serviceName: {
            en: "Application for Water Connection",
            hi: "जल कनेक्शन हेतु आवेदन",
        },
        department: {
            en: "Jal Sansthan",
            hi: "जल संस्थान",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 10,
        serviceName: {
            en: "NOC for Non-Availability of Water by UJS",
            hi: "जल संस्थान द्वारा जल अनुपलब्धता हेतु एनओसी",
        },
        department: {
            en: "Jal Sansthan",
            hi: "जल संस्थान",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 11,
        serviceName: {
            en: "Consent to Establish under Air & Water Acts – Fresh",
            hi: "वायु एवं जल अधिनियम के अंतर्गत स्थापना हेतु सहमति – नवीन",
        },
        department: {
            en: "UKPCB",
            hi: "उत्तराखंड प्रदूषण नियंत्रण बोर्ड",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 12,
        serviceName: {
            en: "Sewer Connection",
            hi: "सीवर कनेक्शन",
        },
        department: {
            en: "Jal Sansthan",
            hi: "जल संस्थान",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 13,
        serviceName: {
            en: "Letter for Distance from Forest",
            hi: "वन से दूरी प्रमाण पत्र",
        },
        department: {
            en: "Forest",
            hi: "वन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 14,
        serviceName: {
            en: "Approval of Drawings/Plans under Electricity Act, 2003 (Generator Set)",
            hi: "विद्युत अधिनियम, 2003 के अंतर्गत आरेख/मानचित्र स्वीकृति (जनरेटर सेट)",
        },
        department: {
            en: "Electrical Inspectorate",
            hi: "विद्युत निरीक्षक विभाग",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
];

export const preOperationalServices = [
    {
        id: 1,
        serviceName: {
            en: "Registration for Hotels & Other Tourism Related Facilities",
            hi: "होटल एवं अन्य पर्यटन संबंधी सुविधाओं का पंजीकरण",
        },
        department: {
            en: "Tourism",
            hi: "पर्यटन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://uttarakhandtourism.gov.in",
    },
    {
        id: 2,
        serviceName: {
            en: "Completion cum Occupancy Certificate",
            hi: "निर्माण पूर्णता एवं अधिभोग प्रमाण पत्र",
        },
        department: {
            en: "Housing",
            hi: "आवास",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 3,
        serviceName: {
            en: "License under the Contract Labour Act, 1970",
            hi: "ठेका श्रम अधिनियम, 1970 के अंतर्गत लाइसेंस",
        },
        department: {
            en: "Labour",
            hi: "श्रम",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 4,
        serviceName: {
            en: "Consolidated Consent & Authorization (CCA)",
            hi: "समेकित सहमति एवं प्राधिकरण (CCA)",
        },
        department: {
            en: "Pollution",
            hi: "प्रदूषण नियंत्रण",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 5,
        serviceName: {
            en: "Pre-operational Fire NOC",
            hi: "पूर्व-संचालन अग्नि अनापत्ति प्रमाण पत्र (Fire NOC)",
        },
        department: {
            en: "Fire",
            hi: "अग्निशमन",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 6,
        serviceName: {
            en: "Food License",
            hi: "खाद्य लाइसेंस",
        },
        department: {
            en: "FSSAI",
            hi: "एफएसएसएआई",
        },
        centralState: {
            en: "Central",
            hi: "केंद्रीय",
        },
        portal: "https://fssai-license.in/",
    },
    {
        id: 7,
        serviceName: {
            en: "Registration of Principal Employer under Inter-State Migrant Workmen Act, 1979 (5 or more workers) – Conditional",
            hi: "अंतर्राज्यीय प्रवासी श्रमिक अधिनियम, 1979 के अंतर्गत प्रमुख नियोक्ता का पंजीकरण (5 या अधिक श्रमिक) – सशर्त",
        },
        department: {
            en: "Labour",
            hi: "श्रम",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 8,
        serviceName: {
            en: "License of Contractor under Inter-State Migrant Workmen Act, 1979 – Conditional",
            hi: "अंतर्राज्यीय प्रवासी श्रमिक अधिनियम, 1979 के अंतर्गत ठेकेदार का लाइसेंस – सशर्त",
        },
        department: {
            en: "Labour",
            hi: "श्रम",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 9,
        serviceName: {
            en: "Application for Load Reduction – Conditional",
            hi: "विद्युत भार घटाने हेतु आवेदन – सशर्त",
        },
        department: {
            en: "UPCL",
            hi: "यूपीसीएल",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 10,
        serviceName: {
            en: "Application for Load Enhancement – Conditional",
            hi: "विद्युत भार बढ़ाने हेतु आवेदन – सशर्त",
        },
        department: {
            en: "UPCL",
            hi: "यूपीसीएल",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 11,
        serviceName: {
            en: "Registration under Indian Boilers Act, 1923 – Conditional",
            hi: "भारतीय बॉयलर अधिनियम, 1923 के अंतर्गत पंजीकरण – सशर्त",
        },
        department: {
            en: "Labour",
            hi: "श्रम",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 12,
        serviceName: {
            en: "FL-6 (Bar License to Operate in Hotel)",
            hi: "FL-6 (होटल में बार संचालन हेतु लाइसेंस)",
        },
        department: {
            en: "Excise",
            hi: "आबकारी",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 13,
        serviceName: {
            en: "FL-6A Composite License (Hotel Premises)",
            hi: "FL-6A संयुक्त लाइसेंस (होटल परिसर)",
        },
        department: {
            en: "Excise",
            hi: "आबकारी",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
    {
        id: 14,
        serviceName: {
            en: "FL-7 (Bar License to Operate in Restaurant)",
            hi: "FL-7 (रेस्टोरेंट में बार संचालन हेतु लाइसेंस)",
        },
        department: {
            en: "Excise",
            hi: "आबकारी",
        },
        centralState: {
            en: "State",
            hi: "राज्य",
        },
        portal: "https://investuttarakhand.uk.gov.in",
    },
];

export const applicationProcessData = {
    heading: {
        en: "Application Process",
        hi: "आवेदन प्रक्रिया",
    },
    tabs: [
        {
            id: "tab1",
            title: {
                en: "Single Window Portal Flow Chart",
                hi: "सिंगल विण्डों पोर्टल फ्लो चार्ट",
            },
            icon: iconPrayatanUddamiProtsahanYojna,
            iconClasses: "brightness-0",
            img: imgPrayatanUddamiProtsahanYojna,
            description: SingleWindowPortalChart,
            props: null,
            active: true,
        },
        {
            id: "tab4",
            title: {
                en: "Pre-Establishment Services",
                hi: "स्थापना-पूर्व सेवाएं",
            },
            icon: iconDeenDayalUpadhyayYojna,
            iconClasses: "brightness-0",
            img: imgDeenDayalUpadhyayYojna,
            description: PreEstOpService,
            props: preEstablishmentServices,
            active: false,
        },
        {
            id: "tab3",
            title: {
                en: "Pre-Operational Services",
                hi: "संचालन पूर्व सेवाएँ",
            },
            icon: iconVeerChandSinghGarhwaliYojna,
            iconClasses: "brightness-0",
            img: imgVeerChandSinghGarhwaliYojna,
            description: PreEstOpService,
            props: preOperationalServices,
            active: false,
        },
        {
            id: "tab2",
            title: {
                en: "Subsidy Claim / Registration Flow Chart",
                hi: "अनुदान दावा / पंजीकरण प्रक्रिया",
            },
            icon: iconTourismPolicies2023,
            iconClasses: "brightness-0",
            img: imgTourismPolicies2023,
            description: SubsidyClaimRegistration,
            props: null,
            active: false,
        },
    ],
};

export const opportunityData = {
    heading: {
        en: "Why Invest in",
        hi: "उत्तराखण्ड",
    },
    subHeading: {
        en: "Uttarakhand",
        hi: "में निवेश क्यों करें",
    },
    subText: {
        en: "Investing in Uttarakhand offers a unique opportunity to tap into a region brimming with natural beauty, skilled manpower, and a conducive business environment, creating a recipe for success.",
        hi: "उत्तराखण्ड में निवेश करना एक विशिष्ट अवसर प्रदान करता है, जहाँ प्राकृतिक सौन्दर्य, कुशल मानव संसाधन एवं व्यवसाय के लिए अनुकूल वातावरण का उत्कृष्ट संगम उपलब्ध है। यह संयोजन निवेशकों के लिए सफलता की मजबूत आधारशिला तैयार करता है।",
    },
    button: {
        text: {
            en: "Explore More",
            hi: "और जानें",
        },
        link: INVEST_UK_WEBSITE_URL,
        bgColor: "bg-[#FF9810]",
    },
    items: [
        {
            title: { en: "Ease of Doing Business", hi: "व्यवसाय करने में आसानी" },
            icon: PeaceBusinessIcon,
            src: peaceBusiness,
        },
        {
            title: { en: "2.5 hours from Delhi NCR", hi: "दिल्ली एनसीआर से मात्र 2.5 घंटे" },
            icon: DelhiNCRIcon,
            src: delhiNCR,
        },
        {
            title: { en: "Economic Power", hi: "आर्थिक क्षमता" },
            icon: EconomicPowerIcon,
            src: economicPower,
        },
        {
            title: { en: "Single Window Portal", hi: "सिंगल विंडो पोर्टल" },
            icon: SingleWindowIcon,
            src: singleWindow,
        },
        {
            title: {
                en: "Robust Industrial Infrastructure",
                hi: "मजबूत औद्योगिक अवसंरचना",
            },
            icon: IndustrialInfraIcon,
            src: industrialInfra,
        },
        {
            title: {
                en: "Industry Ready Skilled Workforce",
                hi: "उद्योग हेतु तैयार कुशल कार्यबल",
            },
            icon: SkilledWorkforceIcon,
            src: skilledWorkForce,
        },
        {
            title: {
                en: "Investor Friendly Policies",
                hi: "निवेशक अनुकूल नीतियाँ",
            },
            icon: InvestorFriendlyIcon,
            src: investorFriendly,
        },
        {
            title: {
                en: "Spiritual Capital of the world",
                hi: "विश्व की आध्यात्मिक राजधानी",
            },
            icon: SpiritualCapitalIcon,
            src: spiritualCapital,
        },
    ],
};

// src/config/investmentSectorData.js
export const investmentSectorData = {
    heading: {
        en: "Investment Sectors",
        hi: "निवेश क्षेत्र",
    },
    highlightColor: "#FF9810",
    items: [
        {
            title: { en: "Industries", hi: "उद्योग" },
            description: {
                en: "Opportunities across manufacturing units, MSMEs, and industrial infrastructure supporting sustainable economic growth.",
                hi: "विनिर्माण इकाइयों, एमएसएमई और औद्योगिक अवसंरचना में निवेश के अवसर, जो सतत आर्थिक विकास को बढ़ावा देते हैं।",
            },
            img: imgIndustryTourism,
            alt: { en: "Industries", hi: "उद्योग" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_Manufacturing.pdf",
        },
        {
            title: { en: "Tourism & Wellness", hi: "पर्यटन एवं वेलनेस" },
            description: {
                en: "Investment potential in eco-tourism, wellness resorts, hospitality projects, and destination development.",
                hi: "इको-टूरिज्म, वेलनेस रिसॉर्ट्स, हॉस्पिटैलिटी परियोजनाओं एवं पर्यटन स्थलों के विकास में निवेश की संभावनाएं।",
            },
            img: imgIndustryWellness,
            alt: { en: "Tourism & Wellness", hi: "पर्यटन एवं वेलनेस" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_Tourism.pdf",
        },
        {
            title: { en: "Agri & Allied", hi: "कृषि एवं संबद्ध क्षेत्र" },
            description: {
                en: "Focus on organic farming, food processing, agri-business, and technology-driven agricultural initiatives.",
                hi: "जैविक खेती, खाद्य प्रसंस्करण, कृषि व्यवसाय एवं तकनीक आधारित कृषि पहलों पर विशेष ध्यान।",
            },
            img: imgIndustryAgriAllied,
            alt: { en: "Agri & Allied", hi: "कृषि एवं संबद्ध क्षेत्र" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_Agriculture.pdf",
        },
        {
            title: { en: "Education", hi: "शिक्षा" },
            description: {
                en: "Development of educational institutions, skill centers, research hubs, and digital learning ecosystems.",
                hi: "शैक्षणिक संस्थानों, कौशल विकास केंद्रों, अनुसंधान हब और डिजिटल शिक्षण पारिस्थितिकी तंत्र का विकास।",
            },
            img: imgIndustryEducation,
            alt: { en: "Education", hi: "शिक्षा" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_Education.pdf",
        },
        {
            title: { en: "Healthcare", hi: "स्वास्थ्य सेवा" },
            description: {
                en: "Investment in hospitals, diagnostic centers, medical infrastructure, and healthcare service expansion.",
                hi: "अस्पतालों, डायग्नोस्टिक केंद्रों, चिकित्सा अवसंरचना एवं स्वास्थ्य सेवाओं के विस्तार में निवेश।",
            },
            img: imgIndustryHealth,
            alt: { en: "Healthcare", hi: "स्वास्थ्य सेवा" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_Healthcare.pdf",
        },
        {
            title: { en: "IT & ITeS", hi: "आईटी एवं आईटीईएस" },
            description: {
                en: "Growth opportunities in software development, IT services, BPO operations, and digital innovation.",
                hi: "सॉफ्टवेयर विकास, आईटी सेवाओं, बीपीओ संचालन और डिजिटल नवाचार में विकास के अवसर।",
            },
            img: imgIndustryIT,
            alt: { en: "IT & ITeS", hi: "आईटी एवं आईटीईएस" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/focus_Sector_IT&ITeS.pdf",
        },
        {
            title: { en: "Renewable Energy", hi: "नवीकरणीय ऊर्जा" },
            description: {
                en: "Projects in solar, wind, hydropower, and clean energy solutions promoting sustainable development.",
                hi: "सौर, पवन, जलविद्युत एवं स्वच्छ ऊर्जा परियोजनाएं, जो सतत विकास को प्रोत्साहित करती हैं।",
            },
            img: imgIndustryRenewable,
            alt: { en: "Renewable Energy", hi: "नवीकरणीय ऊर्जा" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/renewableEnergy.pdf",
        },
        {
            title: { en: "Real Estate", hi: "रियल एस्टेट" },
            description: {
                en: "Commercial, residential, and infrastructure projects supporting urban and regional development.",
                hi: "वाणिज्यिक, आवासीय एवं अवसंरचना परियोजनाएं जो शहरी और क्षेत्रीय विकास को समर्थन देती हैं।",
            },
            img: imgIndustryRealEstate,
            alt: { en: "Real Estate", hi: "रियल एस्टेट" },
            url: "https://investuttarakhand.uk.gov.in/themes/backend/uploads/housingAndUrban.pdf",
        },
    ],
};

export const tourismGrowthData = {
    heading: {
        en: "Growth of Tourism Industry",
        hi: "पर्यटन उद्योग का विकास",
    },
    highlightColor: "#018f9b",
    description: {
        en: "The tourism industry in Uttarakhand has experienced significant growth in recent years, driven by its diverse offerings in religious tourism, adventure sports, and eco-tourism.",
        hi: "उत्तराखण्ड में पर्यटन उद्योग ने हाल के वर्षों में उल्लेखनीय वृद्धि दर्ज की है, जिसका प्रमुख कारण धार्मिक पर्यटन, साहसिक खेलों एवं इको-टूरिज्म जैसे विविध क्षेत्रों में उपलब्ध व्यापक संभावनाएँ हैं।",
    },
    button: {
        text: {
            en: "Explore More",
            hi: "और जानें",
        },
        link: INVEST_UK_WEBSITE_URL,
        bgColor: "bg-[#018f9b]",
    },
    charts: [
        {
            title: {
                en: "Tourist Arrivals – Domestic (In Lakhs)",
                hi: "पर्यटकों का आगमन – घरेलू (लाखों में)",
            },
            data: {
                labels: [
                    { en: "2022", hi: "2022" },
                    { en: "2023", hi: "2023" },
                    { en: "2024", hi: "2024" },
                    { en: "2025", hi: "2025" }
                ],
                datasets: [
                    {
                        label: {
                            en: "Domestic Tourists",
                            hi: "घरेलू पर्यटक",
                        },
                        data: [53917, 59488, 59374, 60129],
                        backgroundColor: ["#1D4ED8", "#16A34A", "#FACC15", "#FB923C"],
                    },
                ],
            },
        },
        {
            title: {
                en: "Tourist Arrivals – Foreigners (In Lakhs)",
                hi: "पर्यटकों का आगमन – विदेशी (लाखों में)",
            },
            data: {
                labels: [
                    { en: "2022", hi: "2022" },
                    { en: "2023", hi: "2023" },
                    { en: "2024", hi: "2024" },
                    { en: "2025", hi: "2025" }
                ],
                datasets: [
                    {
                        label: {
                            en: "Foreign Tourists",
                            hi: "विदेशी पर्यटक",
                        },
                        data: [64.5, 148, 176, 193],
                        backgroundColor: ["#1D4ED8", "#16A34A", "#FACC15", "#FB923C"],
                    },
                ],
            },
        },
    ],
    backgroundImg: imgFeature,
};

export const brandLogos = [
    { src: logoVana, alt: "Vana Logo" },
    { src: logoLeisureHotels, alt: "Leisure Hotels Logo" },
    { src: logoJaypee, alt: "Jaypee Logo" },
    { src: logoFortune, alt: "Fortune Logo" },
    { src: logoTaj, alt: "Taj Logo" },
    { src: logoVana, alt: "Vana Logo" },
    { src: logoLeisureHotels, alt: "Leisure Hotels Logo" },
    { src: logoJaypee, alt: "Jaypee Logo" },
    { src: logoFortune, alt: "Fortune Logo" },
    { src: logoTaj, alt: "Taj Logo" },
];

export const footerConfig = {
    contactInfo: [
        {
            icon: address,
            label: {
                en: `Uttarakhand Tourism Development Board,
Pt. Deen Dayal Upadhyay Paryatan Bhawan
Near ONGC Helipad,
Garhi Cantt, Dehradun,
Uttarakhand 248001`,
                hi: `उत्तराखंड पर्यटन विकास बोर्ड,
पं. दीन दयाल उपाध्याय पर्यटन भवन
ओएनजीसी हेलीपैड के पास,
गढ़ी कैंट, देहरादून,
उत्तराखंड 248001`,
            },
        },
        {
            icon: mail,
            label: {
                en: "publicityutdb [at] gmail [dot] com",
                hi: "publicityutdb [at] gmail [dot] com",
            },
        },
        {
            icon: phone,
            href: "tel:+911352559898",
            label: {
                en: "+91 135-2559898, 2559987",
                hi: "+91 135-2559898, 2559987",
            },
        },
    ],

    quickLinks: [
        { label: { en: "Home", hi: "मुख्य पृष्ठ" }, href: "" },
        { label: { en: "Policies", hi: "नीतियाँ" }, href: "Policies" },
        { label: { en: "Contact Us", hi: "संपर्क करें" }, href: "contact-section" },
    ],

    policies: [
        {
            label: {
                en: "Uttarakhand Paryatan Udhyami Protsahan Yojana",
                hi: "उत्तराखंड पर्यटन उद्यमी प्रोत्साहन योजना",
            },
            href: "/prayatan-yojana",
        },
        {
            label: {
                en: "Tourism Policy 2023",
                hi: "पर्यटन नीति 2023",
            },
            href: "/tourism-policy-2023",
        },
        {
            label: {
                en: "Veer Chand Singh Garhwali, Tourism Self-Employment Scheme",
                hi: "वीरचंद्र सिंह गढ़वाली, पर्यटन स्वरोजगार योजना",
            },
            href: "/veer-chand-yojana",
        },
        {
            label: {
                en: "Deen Dayal Upadhyay Housing Scheme (Home-Stay)",
                hi: "दीन दयाल उपाध्याय गृह आवास योजना",
            },
            href: "/deen-dayal-yojana",
        },
        {
            label: {
                en: "TIFC",
                hi: "टीआईएफसी",
            },
            href: "/tifc-faciliation",
        },
    ],

    socialLinks: [
        { icon: insta, alt: "Instagram", href: "https://www.instagram.com/uttarakhand_tourismofficial" },
        { icon: linkedin, alt: "LinkedIn", href: "https://www.linkedin.com/company/uttarakhand_tourismofficial" },
        { icon: pinterest, alt: "Pinterest", href: "https://in.pinterest.com/utdbtourism" },
        { icon: facebook, alt: "Facebook", href: "https://www.facebook.com/UttarakhandTourismOfficialPage" },
        { icon: youtube, alt: "YouTube", href: "https://www.youtube.com/channel//UCX7c5KGrPjG8tzna7xhro4g" },
    ],

    govtLogo: govtLogos,
};

export const financialIncentivesData = [
    {
        section: {
            hi: "स्टाम्प ड्यूटी प्रतिपूर्ति",
            en: "Stamp Duty Reimbursement",
        },
        details: [
            {
                hi: "नई इकाइयों की स्थापना पर स्टाम्प ड्यूटी की 100% प्रतिपूर्ति।",
                en: "100% reimbursement of stamp duty on the establishment of new units.",
            },
        ],
    },
    {
        section: {
            hi: "पूंजी प्रोत्साहन / अनुदान",
            en: "Capital Incentives / Grants",
        },
        details: [
            {
                hi: "₹1 करोड़ के निवेश पर न्यूनतम ₹33 लाख की सब्सिडी।",
                en: "Minimum subsidy of ₹33 lakhs for an investment of ₹1 crore.",
            },
            {
                hi: "श्रेणी A: 15% अतिरिक्त सब्सिडी (अधिकतम ₹80 लाख)।",
                en: "Category A: 15% additional subsidy (maximum ₹80 lakhs).",
            },
            {
                hi: "श्रेणी B: 25% अतिरिक्त सब्सिडी (अधिकतम ₹1.20 करोड़)।",
                en: "Category B: 25% additional subsidy (maximum ₹1.20 crores).",
            },
            {
                hi: "श्रेणी C: 30% अतिरिक्त सब्सिडी (अधिकतम ₹1.50 करोड़)।",
                en: "Category C: 30% additional subsidy (maximum ₹1.50 crores).",
            },
        ],
    },
    {
        section: {
            hi: "ब्याज सहायता",
            en: "Interest Assistance",
        },
        details: [
            {
                hi: "टर्म लोन पर 3 वर्षों तक ब्याज सहायता:",
                en: "Interest assistance on term loans for 3 years:",
            },
            {
                hi: "श्रेणी A: 3% (अधिकतम ₹4 लाख प्रति वर्ष)",
                en: "Category A: 3% (max ₹4 lakhs per year)",
            },
            {
                hi: "श्रेणी B: 3% (अधिकतम ₹5 लाख प्रति वर्ष)",
                en: "Category B: 3% (max ₹5 lakhs per year)",
            },
            {
                hi: "श्रेणी C: 3% (अधिकतम ₹6 लाख प्रति वर्ष)",
                en: "Category C: 3% (max ₹6 lakhs per year)",
            },
        ],
    },
];

export const guidelinesDataPrayatanYojna = {
    timeline: [
        {
            desc: {
                en: "Timeline for completion of project",
                hi: "योजना पूर्ण करने की समयसीमा",
            },
            time: {
                en: "Within a period of 3 years from the date of CAF approval",
                hi: "कैफ अनुमोदन की तिथि से अधिकतम 03 वर्ष की सीमा-निश्चित",
            },
        },
        {
            desc: {
                en: "Application for first installment of capital subsidy and stamp duty reimbursement",
                hi: "पूंजीगत अनुदान की प्रथम किश्त व स्टांप शुल्क प्रतिपूर्ति हेतु आवेदन",
            },
            time: {
                en: "Within six months (180 days) from commencement of operations",
                hi: "व्यावसायिक संचालन की तिथि से अधिकतम 6 माह (180 दिन) के भीतर",
            },
        },
        {
            desc: {
                en: "Application for first installment of interest subsidy",
                hi: "ब्याज अनुदान की प्रथम किश्त हेतु आवेदन",
            },
            time: {
                en: "Within 90 days after end of 1 year from commencement",
                hi: "व्यावसायिक संचालन प्रारम्भ की तिथि से 01 वर्ष की समाप्ति के 90 दिनों के भीतर",
            },
        },
    ],

    downloads: {
        govt: [
            {
                label: {
                    en: "Government Order",
                    hi: "योजना स्वीकृति का शासनादेश",
                },
                file: GovernmentOrderParyatanUdhyamiPDF,
            },
            {
                label: {
                    en: "Operational Guideline",
                    hi: "ऑपरेशनल गाइड लाइन",
                },
                file: OperationalGuidelinesParyatanUdyamiPDF,
            },
        ],

        docs: [
            {
                label: { en: "Checklist", hi: "चेकलिस्ट" },
                file: CheckListPDF,
            },
            {
                label: { en: "Affidavit (Format)", hi: "शपथ पत्र (प्रारूप)" },
                file: AffidavitPDF,
            },
            {
                label: { en: "Bank Interest Certificate", hi: "बैंक ब्याज प्रमाणपत्र (प्रारूप)" },
                file: BankIntrestCertificatePDF,
            },
            {
                label: { en: "CA Certificate", hi: "सीए प्रमाणपत्र (प्रारूप)" },
                file: CACertificatePDF,
            },
            {
                label: { en: "CE/Architect Certificate", hi: "सीई/आर्किटेक्ट प्रमाणपत्र (प्रारूप)" },
                file: CEArchitectPDF,
            },
        ],
    },
};

export const guidelinesDataTourismPolicy2023 = {
    downloads: {
        govt: [
            {
                label: {
                    en: "Policy",
                    hi: "नीति",
                },
                file: TourismPolicy2023PDF,
            },
            {
                label: {
                    en: "Policy Ammendment",
                    hi: "नीति संशोधन",
                },
                file: AmendedModificationsTourismPolicy2023PDF,
            },
            {
                label: {
                    en: "Operational Guideline",
                    hi: "ऑपरेशनल गाइड लाइन",
                },
                file: OperationalGuidelinesTourismPolicy2023PDF,
            },
            {
                label: {
                    en: "Operational Guideline Ammendment",
                    hi: "ऑपरेशनल गाइड लाइन संशोधन",
                },
                file: AmendmentOperationalGuidelinesTourismPolicy2023PDF,
            },
            {
                label: {
                    en: "Operational Guideline (Hindi)",
                    hi: "ऑपरेशनल गाईड लाईन (हिंदी)",
                },
                file: OGTourismPolicy2023Hindi,
            },

        ],
    },
};


